var map = {
	"./21c-logo.png": 2695,
	"./25hours.png": 5093,
	"./Accor_Logo (1) 1.png": 5288,
	"./Adagio.png": 3690,
	"./AdagioPremium.png": 7327,
	"./ArtSeries.png": 1325,
	"./Breakfree.png": 8106,
	"./Fairmont.png": 6289,
	"./Grand_Mercure.png": 7937,
	"./Handwritten.png": 8217,
	"./JO&JOE.png": 9568,
	"./MGallery.png": 2896,
	"./Mama_Shelter.png": 6851,
	"./Mantra.png": 3570,
	"./Mercure.png": 6094,
	"./Mövenpick.png": 2510,
	"./Novotel.png": 9050,
	"./OUR-HABITAS.png": 6954,
	"./Peppers.png": 3358,
	"./Pullman.png": 4510,
	"./Raffles.png": 7636,
	"./Sofitel.png": 1145,
	"./Tribe.png": 1121,
	"./banyan_tree.png": 4689,
	"./gleneagles.png": 7678,
	"./greet.png": 7002,
	"./hotelF1.png": 7296,
	"./ibis.png": 5908,
	"./ibis_Budget.png": 2086,
	"./ibis_Styles.png": 6075,
	"./mondrian.png": 7473,
	"./rixos.png": 7014,
	"./swissotel.png": 8970
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4874;